export type Currency = "NZD" | "EUR";

/**
 * en-US renders NZD as "NZ$" (en-NZ would print a bare "$"), en-IE renders EUR as "€".
 */
const CURRENCY_LOCALE: Record<Currency, string> = {
	NZD: "en-US",
	EUR: "en-IE",
};

const currencyFormatters: Record<Currency, Intl.NumberFormat> = {
	NZD: new Intl.NumberFormat(CURRENCY_LOCALE.NZD, {
		style: "currency",
		currency: "NZD",
		maximumFractionDigits: 0,
	}),
	EUR: new Intl.NumberFormat(CURRENCY_LOCALE.EUR, {
		style: "currency",
		currency: "EUR",
		maximumFractionDigits: 0,
	}),
};

/** Format a whole-unit amount (prices are stored as integers, not cents). */
export const formatCurrency = (amount: number, currency: Currency): string =>
	currencyFormatters[currency].format(amount);

export class FormatterService {
	currency: Intl.NumberFormat;
	dateLong: Intl.DateTimeFormat;
	dateShort: Intl.DateTimeFormat;

	constructor() {
		this.currency = currencyFormatters.NZD;

		this.dateLong = new Intl.DateTimeFormat("en", {
			month: "long",
			day: "numeric",
			year: "numeric",
		});

		this.dateShort = new Intl.DateTimeFormat("en", {
			month: "short",
			day: "numeric",
			year: "numeric",
		});
	}
}
